import { Collapse, Divider, Typography, makeStyles } from "@material-ui/core";
import React, { useCallback } from "react";

import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2),
    paddingTop: theme.spacing(1),
    backgroundColor: "#ffffcc",
    borderTopLeftRadius: theme.spacing(1),
    borderTopRightRadius: theme.spacing(1),
  },
  caption: {
    fontWeight: "bold",
    cursor: "pointer",

    "& svg": {
      display: "inline-block",
      float: "left",
    },
  },
  value: {
    paddingBottom: theme.spacing(2),
    fontSize: 14,
    paddingRight: theme.spacing(2),
  },
  divider: {
    display: "block",
    clear: "both",
  },
}));
const EvalSuggestionField = ({ caption, value }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleClick = useCallback(() => setOpen((open) => !open), []);
  return (
    <div className={classes.root} onClick={handleClick}>
      <Typography className={classes.caption} variant="caption">
        {caption}
        {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
      </Typography>
      <Collapse in={open}>
        <Typography className={classes.value} variant="body2" align="justify">
          {value}
        </Typography>
      </Collapse>
      <Divider className={classes.divider} />
    </div>
  );
};
export default EvalSuggestionField;
